import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import './Grid.scss';

const Grid = ({ children }) => <div className="grid">{children}</div>;

Grid.propTypes = {
  children: propTypes.node.isRequired
};

Grid.Item = ({
  children,
  width,
  extraPadding = false,
  tabletWidth = width,
  grow = false,
  tabletGrow = grow
}) => (
  <div
    className={classNames('grid__item', {
      [`grid__item--${width}`]: true,
      [`grid__item--tablet-${tabletWidth}`]: true,
      'grid__item--extra-padding': extraPadding,
      'grid__item--grow': grow,
      'grid__item--tablet-grow': tabletGrow,
    })}>
    {children}
  </div>
);

Grid.Item.propTypes = {
  children: propTypes.node.isRequired,
  extraPadding: propTypes.bool,
  grow: propTypes.bool,
  tabletGrow: propTypes.bool,
  tabletWidth: propTypes.number,
  width: propTypes.number.isRequired
};

export default Grid;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductGrid/Grid/Grid.js